import { employeeActionsFormPrefix } from 'modules/employeeActionsForm/store/actions';
import { createSingleAction } from 'store/utils';

const SET_END_ASSIGNMENT_ID = `${employeeActionsFormPrefix}/SET_END_ASSIGNMENT_ID`;
export const setEndAssignmentId = createSingleAction<string | null, typeof SET_END_ASSIGNMENT_ID>(
    SET_END_ASSIGNMENT_ID,
);
